import { __assign } from "tslib";
import React from 'react';
import pick from 'lodash/pick';
import Tabs from '../';
import s from './FormTabs.scss';
export var FormTabs = function (props) {
    return (React.createElement(Tabs, __assign({}, props, { viewClassNames: pick(s, 'root', 'tab', 'active-tab') })));
};
FormTabs.displayName = 'FormTabs';
export default FormTabs;
//# sourceMappingURL=FormTabs.js.map